import {NotificationsSubscriptionsMenu} from '@github-ui/notifications-subscriptions-menu'
import {RepoTemplateIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

import type {HeaderResponse, RepoPaths} from '../types'

export type CodeViewHeaderActionsProps = Pick<
  HeaderResponse,
  | 'repo'
  | 'forksCount'
  | 'stargazerCount'
  | 'showSponsorButton'
  | 'showTemplateButton'
  | 'star'
  | 'fork'
  | 'pin'
  | 'watch'
  | 'viewer'
  | 'showSponsorButton'
> & {
  paths: RepoPaths
}

/** Desktop action button container with Watch, Fork, and Star buttons. */
export function CodeViewHeaderActions({repo, watch, viewer, paths, showTemplateButton}: CodeViewHeaderActionsProps) {
  return (
    <ul className="list-style-none d-flex flex-items-center gap-2 flex-shrink-0 py-1" data-testid="repo-header-actions">
      {viewer.isLoggedIn && watch.canWatch && (
        <li>
          <NotificationsSubscriptionsMenu
            repositoryId={watch.watchData.repositoryId}
            repositoryName={watch.watchData.repositoryName}
            watchersCount={watch.watchData.watchersCount}
            subscriptionType={watch.watchData.subscriptionType}
            subscribableThreadTypes={watch.watchData.subscribableThreadTypes}
            repositoryLabels={watch.watchData.repositoryLabels}
            showLabelSubscriptions={watch.watchData.showLabelSubscriptions}
            subscribedLabelIds={watch.watchData.subscribedLabelIds}
            subscribedLabels={[]}
          />
        </li>
      )}

      {showTemplateButton && repo.isTemplate && (
        <li>
          <Button
            as="a"
            href={paths.templatePath}
            variant="primary"
            size="small"
            leadingVisual={RepoTemplateIcon}
            data-testid="use-template-button"
          >
            Use this template
          </Button>
        </li>
      )}
    </ul>
  )
}
